import React from "react";
import Navbar from "../Navbar/Navbar";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import CommunityMembers from "../Pages/CommunityMembers/CommunityMembers";
import Events from "../Pages/EventsPage/Events";
import Homepage from "../Pages/Homepage/Homepage";
import UserData from "../Pages/UserData/UserData";
import Media from "../Pages/Video-ImagesPage/Media";
import Logout from "../Atoms/Logout/Logout";
import SingleUser from "../SingleUser/SingleUser";
import Skills from "../Pages/skills/Skills";
import Approvals from "../Pages/skills/Approvals";
import SkillsList from "../Pages/skills/SkillsList";
import SelectedSkill from "../Pages/skills/SelectedSkill";
import Segregation from "../Pages/UserData/Segregation";

function Dashboard() {
  return (
    <Router>
      <div style={{ position: "sticky", top: "0", zIndex: "2" }}>
        <Navbar />
        {/* <Button >SignOut</Button> */}
        <Logout />
      </div>
      <Switch>
        <Route path="/CommunityMembers" component={CommunityMembers} />
        <Route path="/Events" component={Events} />
        <Route path="/Homepage" component={Homepage} />
        <Route path="/Home" component={Segregation} />
        <Route path="/UserData" exact component={UserData} />
        <Route path="/UserData/:id" component={SingleUser} />
        <Route path="/Donations" component={Media} />
        <Route path="/Skills" exact component={Skills} />
        <Route path="/Skills/approvals" exact component={Approvals} />
        <Route path="/Skills/list" exact component={SkillsList} />
        <Route path="/Skills/list/:id" component={SelectedSkill} />
      </Switch>
    </Router>
  );
}

export default Dashboard;
